var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { getSettingsValue } from '@wix/tpa-settings';
import { isSSR, isSEO } from '../helpers';
import { buildSentryOptions, getArtifactId, getArtifactVersion, getFullArtifactId, getMultilingualLanguage, } from '../utils';
import { ControllerEnvironment } from '../environment/Controller';
import { workerErrorProp } from '../controller/workerErrorProp';
import { FlowAPI } from './Base';
import { openModal } from './utils/openModal';
var OOIControllerFlowAPI = /** @class */ (function (_super) {
    __extends(OOIControllerFlowAPI, _super);
    function OOIControllerFlowAPI(_a) {
        var viewerScriptFlowAPI = _a.viewerScriptFlowAPI, controllerConfig = _a.controllerConfig, appDefinitionId = _a.appDefinitionId, widgetId = _a.widgetId, componentId = _a.componentId, componentName = _a.componentName, biLogger = _a.biLogger, prepopulatedData = _a.prepopulatedData, translations = _a.translations, fedopsConfig = _a.fedopsConfig, sentryConfig = _a.sentryConfig, shouldUseEssentials = _a.shouldUseEssentials, multilingualDisabled = _a.multilingualDisabled, panoramaClient = _a.panoramaClient, locationAPI = _a.locationAPI, windowAPI = _a.windowAPI, siteAPI = _a.siteAPI, seoAPI = _a.seoAPI;
        var _this = this;
        var _b, _c, _d, _e, _f, _g, _h;
        _this = _super.call(this, {
            httpClient: controllerConfig.essentials.httpClient,
        }) || this;
        _this.appLoadStarted = function () {
            if (_this.fedops !== null) {
                var originalAppLoadStarted_1 = _this.fedops.appLoadStarted;
                originalAppLoadStarted_1.call(_this.fedops);
                _this.fedops.appLoadStarted = function () {
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i] = arguments[_i];
                    }
                    console.warn("🥺 Seems like you're trying to call `fedopsLogger.appLoadStarted` and `fedopsLogger.appLoaded` in your controller.\nWe are already logging load events for SSR and CSR environments, so you can remove these calls from your project.");
                    originalAppLoadStarted_1.call.apply(originalAppLoadStarted_1, __spreadArray([_this.fedops], args, false));
                };
            }
        };
        _this.essentials = controllerConfig.essentials;
        _this.controllerConfig = controllerConfig;
        _this.errorHandler =
            (_b = _this.essentials.errorHandler) !== null && _b !== void 0 ? _b : viewerScriptFlowAPI.errorHandler;
        _this.experiments = viewerScriptFlowAPI.experiments;
        _this.bi = viewerScriptFlowAPI.bi;
        _this.prepopulatedData = prepopulatedData;
        _this.componentName = componentName;
        var platformAPIs = controllerConfig.platformAPIs;
        _this.panoramaClient = panoramaClient.createClientForComponent();
        _this.getCurrencyFormatter = viewerScriptFlowAPI.getCurrencyFormatter;
        // TODO: Remove optional chaining after TB will be released for editor
        _this.formatCurrency = (_c = _this.getCurrencyFormatter) === null || _c === void 0 ? void 0 : _c.call(_this);
        _this.formatAddress = viewerScriptFlowAPI.formatAddress;
        _this.environment = new ControllerEnvironment({
            locationAPI: locationAPI,
            windowAPI: windowAPI,
            siteAPI: siteAPI,
            seoAPI: seoAPI,
            appData: controllerConfig.appParams,
            config: controllerConfig.config,
            widgetId: widgetId,
        });
        // If viewer script bi logger wasn't initialized (in case viewer script is external or some error appear here),
        // we still want to init bi logger in controller.
        if (!viewerScriptFlowAPI.bi && biLogger) {
            if (shouldUseEssentials) {
                var biFactory = _this.essentials.biLoggerFactory();
                _this.bi = biLogger(biFactory)({});
            }
            else if ((_d = controllerConfig.platformAPIs) === null || _d === void 0 ? void 0 : _d.biLoggerFactory) {
                _this.bi = biLogger((_e = controllerConfig.platformAPIs) === null || _e === void 0 ? void 0 : _e.biLoggerFactory())({});
            }
        }
        // flowAPI.sentry and  flowAPI.errorMonitor shouldn't be optional for users.
        // If user didn't configure them, then we'll still provide typed object.
        _this.sentry = null;
        _this.errorMonitor = null;
        if ((prepopulatedData === null || prepopulatedData === void 0 ? void 0 : prepopulatedData.sentryMonitor) || (prepopulatedData === null || prepopulatedData === void 0 ? void 0 : prepopulatedData.errorMonitor)) {
            _this.sentry = (_f = prepopulatedData === null || prepopulatedData === void 0 ? void 0 : prepopulatedData.sentryMonitor) !== null && _f !== void 0 ? _f : null;
            _this.errorMonitor = (_g = prepopulatedData === null || prepopulatedData === void 0 ? void 0 : prepopulatedData.errorMonitor) !== null && _g !== void 0 ? _g : null;
        }
        else if (sentryConfig) {
            if (sentryConfig.errorMonitor && _this.essentials.createErrorMonitor) {
                _this.errorMonitor = _this.essentials.createErrorMonitor({
                    dsn: sentryConfig.DSN,
                    environment: 'Viewer:Worker',
                    appName: getArtifactId(),
                    version: getArtifactVersion(),
                    fullArtifactId: getFullArtifactId(),
                    componentId: componentId,
                    tags: {
                        componentId: componentId,
                        componentName: componentName,
                        isSSR: isSSR(windowAPI),
                        isSEO: isSEO(seoAPI),
                    },
                });
            }
            else {
                var sentryOptions_1 = buildSentryOptions({
                    dsn: sentryConfig.DSN,
                    environment: 'Viewer:Worker',
                    release: "".concat(getArtifactId(), "@").concat(getArtifactVersion()),
                    withDataCallback: true,
                    tags: {
                        componentId: componentId,
                        componentName: componentName,
                        isSSR: isSSR(windowAPI),
                        isSEO: isSEO(seoAPI),
                    },
                });
                _this.sentry = (_h = platformAPIs.monitoring) === null || _h === void 0 ? void 0 : _h.createMonitor(sentryOptions_1.dsn, function (config) { return (__assign(__assign({}, config), sentryOptions_1.config)); });
            }
        }
        if (_this.sentry) {
            _this.reportError = function (error) {
                if (typeof error === 'string') {
                    _this.sentry.captureMessage(error);
                }
                else {
                    _this.sentry.captureException(error);
                }
                return _this.sentry.lastEventId();
            };
        }
        if (_this.errorMonitor) {
            _this.reportError = function (error) {
                if (typeof error === 'string') {
                    return _this.errorMonitor.captureMessage(error);
                }
                return _this.errorMonitor.captureException(error);
            };
        }
        // We set null and use typecasting for preserving current API in cased when functional is disabled by user.
        // In future we can change it to mocked implementation.
        _this.fedops = null;
        if ((fedopsConfig === null || fedopsConfig === void 0 ? void 0 : fedopsConfig.enabled) !== false) {
            if (prepopulatedData === null || prepopulatedData === void 0 ? void 0 : prepopulatedData.fedopsLogger) {
                _this.fedops = prepopulatedData === null || prepopulatedData === void 0 ? void 0 : prepopulatedData.fedopsLogger;
            }
            else if (shouldUseEssentials) {
                _this.fedops = _this.essentials.fedopsLogger;
            }
            else {
                _this.fedops = platformAPIs.fedOpsLoggerFactory.getLoggerForWidget({
                    appId: appDefinitionId,
                    widgetId: widgetId,
                    paramsOverrides: { corrId: _this.controllerConfig.compId },
                });
            }
            if (_this.environment.isSSR) {
                _this.appLoadStarted();
            }
            _this.fedops.interactionStarted('controller-load');
        }
        if (_this.environment.isSSR) {
            panoramaClient === null || panoramaClient === void 0 ? void 0 : panoramaClient.reportLoadStart();
        }
        _this.translations = translations;
        _this.viewerScriptFlowAPI = viewerScriptFlowAPI;
        _this.settings = {
            get: function (param) {
                var _a, _b, _c;
                return getSettingsValue((_b = (_a = _this.controllerConfig.config) === null || _a === void 0 ? void 0 : _a.publicData) !== null && _b !== void 0 ? _b : {}, param, {
                    t: (_c = _this.translations) === null || _c === void 0 ? void 0 : _c.t,
                    experiments: _this.experiments,
                    isMobile: _this.environment.isMobile,
                    language: !multilingualDisabled
                        ? getMultilingualLanguage(_this.environment.multilingual)
                        : undefined,
                });
            },
        };
        _this.openModal = openModal;
        return _this;
    }
    OOIControllerFlowAPI.prototype.init = function () {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!(((_a = this.translations) === null || _a === void 0 ? void 0 : _a.i18n) === null)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.translations.init({
                                prepopulated: (_b = this.prepopulatedData) === null || _b === void 0 ? void 0 : _b.translations,
                                useSuspense: this.environment.isEditor || this.environment.isADI,
                            })];
                    case 1:
                        _c.sent();
                        _c.label = 2;
                    case 2:
                        if (this.fedops !== null) {
                            this.fedops.interactionEnded('controller-load');
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    OOIControllerFlowAPI.prototype.updateControllerConfig = function (config) {
        this.controllerConfig.config = config;
    };
    OOIControllerFlowAPI.prototype.handleError = function (error) {
        var errorId;
        if (this.sentry) {
            this.reportError(error);
            errorId = this.sentry.lastEventId();
        }
        if (this.errorMonitor) {
            errorId = this.reportError(error);
        }
        this.controllerConfig.setProps({
            _workerError: workerErrorProp(error, errorId),
        });
    };
    OOIControllerFlowAPI.prototype.withErrorBoundary = function (callback) {
        var _this = this;
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            try {
                callback.apply(void 0, args);
            }
            catch (error) {
                if (error instanceof Error) {
                    _this.handleError(error);
                }
            }
        };
    };
    return OOIControllerFlowAPI;
}(FlowAPI));
export { OOIControllerFlowAPI };
//# sourceMappingURL=OOIController.js.map